import { render, staticRenderFns } from "./noaccess.vue?vue&type=template&id=2025177e&"
import script from "./noaccess.vue?vue&type=script&lang=ts&"
export * from "./noaccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports